import store from '../store/Store';

let featureFlags: Map<string, boolean> | undefined = undefined;
export default function getFeatureFlags(): Map<string, boolean> {
    return (featureFlags ??= store(null).featureFlags);
}
